<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="containerBox">
      <div v-if="!$auth.isAuthenticated" class="row m-0 dashboardBlocksWrapper">
        You must login to access this page
      </div>
    </div>
    <div v-if="$auth.isAuthenticated" class="row m-3 dashboardBlocksWrapper">
      <b-container fluid>
        <b-row cols="1" class="justify-content-md-center border rounded">
          <b-col class="p-10">
            <b-tabs content-class="" class="p-10 m-20" pills>
              <b-row class="device-dropdown" v-if="!showAnnotation">
                <b-col>
                  <b-button
                      v-if="fileStatus === 'TO_DO'"
                      variant="primary"
                      class="justify-content-md-end"
                      @click="tag()"
                  >Annotate
                  </b-button>

                  <b-button
                      v-if="fileStatus === 'NEEDS_REVIEW'"
                      variant="primary"
                      class="justify-content-md-end"
                      @click="tag()"
                  >Review
                  </b-button>
                </b-col>
                <v-select
                    v-model="selectedDevice"
                    :options="deviceIds"
                    @input="setSelectedDevice"
                />

              </b-row>
              <label v-if="fileStatus === 'COMPLETED'">Number of Annotations Uploaded: {{ fileCount }}</label>
              <label v-if="fileStatus === 'NEEDS_REVIEW'">Number of Annotations in Review: {{ fileCount }}</label>
              <b-tab title="To do" active @click="tabClick('TO_DO')">
                <list
                    :files="annotations['TO_DO']"
                    fileStatus="TO_DO"
                    v-if="annotations && annotations['TO_DO'].length > 0 && !showAnnotation"
                    @tag-file="tag"
                />
              </b-tab>
              <b-tab title="Needs Review" @click="tabClick('NEEDS_REVIEW')"
                     v-if="userPermissions.indexOf('review:annotations') >=0">
                <list
                    :files="annotations['NEEDS_REVIEW']"
                    fileStatus="NEEDS_REVIEW"
                    v-if="annotations && annotations['NEEDS_REVIEW'] && annotations['NEEDS_REVIEW'].length > 0 && !showAnnotation"
                    @tag-file="tag"
                />
              </b-tab>
              <b-tab title="Completed" @click="tabClick('COMPLETED')">
                <list
                    :files="annotations['COMPLETED']"
                    v-if="annotations && annotations['COMPLETED'] && annotations['COMPLETED'].length > 0 && !showAnnotation"
                    @tag-file="tag"
                />
              </b-tab>
            </b-tabs>
            <div v-if="showAnnotation">
              <annotate :file="selectedFile" :deviceId="selectedDevice" :fileStatus="fileStatus"/>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import Annotate from "./Annotate.vue";
import List from "./List.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);
Vue.component("annotate", Annotate);
Vue.component("list", List);

export default {
  name: "TrainingTool",
  data() {
    return {
      deviceIds: [],
      deviceList: [],
      showAnnotation: false,
      selectedFile: {name: "", status: ""},
      selectedDevice: "",
      id_token: '',
      serviceUrl: 'https://annotation-service-dot-development-cloud-services.appspot.com',
      // serviceUrl: 'http://localhost:8080',
      annotations: undefined,
      fileStatus: 'TO_DO',
      userPermissions: [],
      fileCount: 0
    };
  },
  async mounted() {
    if (!this.$auth.isAuthenticated) {
      return;
    }
    const claims = await this.$auth.getIdTokenClaims();
    this.userPermissions = claims['https://care.ai/permissions'];
    this.id_token = claims.__raw;
    this.fetchDevices();
  },
  methods: {
    tabClick(fileStatus) {
      this.fileStatus = fileStatus;
      this.showAnnotation = false;
      this.getAnnotationFiles(this.selectedDevice, fileStatus);
    },
    tag() {
      this.showAnnotation = true;
    },
    setSelectedDevice(value) {
      this.getAnnotationFiles(value, this.fileStatus);
    },
    async fetchDevices() {
      const url = this.serviceUrl + `/devices/`;
      let device_request = new Request(url, {
        method: "GET",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + this.id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var statusReportResponse = await this.fetch_retry(2, 5, device_request);
        if (statusReportResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (statusReportResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          return;
        }
        this.deviceList = await statusReportResponse.json();
        this.deviceIds = this.deviceList.map(x => {
          return x && x.deviceId
        });
        this.selectedDevice = this.deviceIds[0];
        this.getAnnotationFiles(this.selectedDevice, 'TO_DO');
      } catch (e) {
        console.error(e);
      }
    },
    fetch_retry(delay, retires, request_option) {
      return new Promise((resolve, reject) => {
        const wait = (delay) => {
          return new Promise((resolve) => {
            setTimeout(resolve, delay * 1000)
          })
        };
        const onError = (err) => {
          let triesLeft = retires - 1;
          if (!triesLeft) {
            throw err;
          }
          return wait(delay).then(() => {
            this.fetch_retry(delay, triesLeft, request_option)
          })
        }
        fetch(request_option)
            .then(result => {
              if (result && result.status === 503) {
                onError('503 request')
              } else {
                resolve(result)
              }
            })
            .catch(err => {
              reject('failed');
            })
      })
    },
    async getAnnotationFiles(deviceId, fileStatus) {
      const url = this.serviceUrl + `/devices/` + deviceId + '/annotation-file-list?type=' + fileStatus + '&limit=50&offset=0';
      let device_request = new Request(url, {
        method: "GET",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + this.id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var statusReportResponse = await this.fetch_retry(2, 5, device_request);
        if (statusReportResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (statusReportResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          return;
        }
        const annotations = await statusReportResponse.json();
        if (this.annotations === undefined) {
          this.annotations = [];
        }
        this.annotations[fileStatus] = annotations.annotations;
        this.fileCount = annotations.fileCount;
        this.$forceUpdate();
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>
<style>
.list-group, .vs__selected {
  color: #6a6a6a;
}

.vs__actions {
  padding-top: 5px;
}

button.vs__clear svg {
  margin-top: -3px;
}

.nav-pills .nav-link,
.nav-pills {
  border: none;
  color: #484848;
  margin: 0;
}

.nav-pills .nav-link {
  margin: 15px 15px 15px 0;
  border: 1px solid #dceaea;
  padding: 0.438rem 1rem;
}

.nav-pills .nav-link:hover {
  background: #fff;
  color: #00b5da;
}

.nav-pills .nav-link.active {
  background: #484848;
  color: white;
}

/* .nav-pills .nav-item {
	width: calc(100% / 3);
} */
.device-dropdown {
  margin-right: 15px;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 0;
  top: 15px;
}

.device-dropdown div:first-child {
  width: 211px;
  height: 40px;
  display: flex;
  align-items: center;
}

.device-dropdown .col {
  display: flex;
  justify-content: flex-end;
}
</style>
